<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 10:55:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-05-20 16:30:21
 * @FilePath: 
 * @Description: 选择人数页面
-->
<template>
  <div class="check_person_con">
    <div class="person_title_con">
      <img src="@/assets/images/point-user.png" alt="" />
      <p class="c-ft-26">亲爱的顾客，欢迎您用餐～</p>
    </div>
    <div class="select_number_con">
      <div class="c-ft-32">请问您几人用餐？</div>
      <div class="select_tips c-ft-26">
        <p>请选择人数</p>
      </div>
      <ul class="table_number_con">
        <li
          v-for="(item, index) in 11"
          :class="[{ active_item: tableNumber == item }, 'table_number_item']"
          :key="index"
          @click="onClickTableNumber(item)"
        >
          {{ item }}
        </li>
        <li
          :class="[{ active_item: tableNumber == 'more' }, 'table_number_item']"
          @click="onClickTableNumber('more')"
        >
          更多
        </li>
      </ul>
      <van-field
        v-if="tableNumber == 'more'"
        v-model="inputTableNumber"
        type="digit"
        label=""
        placeholder="请输入人数"
      />

      <div class="number_submit_btns">
        <van-button
          v-if="fromPage == 'NewPlaceOrder' && !isFromMicropoint"
          color="#E1EDDE"
          block
          round
          class="custom-button"
          @click="handleToOrderPage"
          >确定</van-button
        >
        <van-button
          v-else
          color="#E1EDDE"
          block
          round
          class="custom-button"
          @click="handleToOrderPage"
          >{{ isFromMicropoint ? "继续下单" : "开始点餐" }}</van-button
        >
      </div>
    </div>

    <van-overlay :show="showSelectModal" z-index="5">
      <div class="overlay_con" style="margin-left: 10px;margin-right: 10px;">
      
        <div class="overlay_con_content">
        <p style="text-align: center; height: 60px; line-height: 60px;font-weight: bold;">
          温馨提示
        </p>
        <div style="display: flex">
          <img
           class="overlay_con_img"
            src="@/assets/order/1@2x(6).png"
            alt=""
          />
          <p class="overlay_con_p" >合理点餐，请勿浪费食物～ </p>
          <div style="flex: 1" />
        </div>
        <div style="display: flex">
          <img
            src="@/assets/order/1@2x(7).png"
              class="overlay_con_img"
            alt=""
          />
          <p class="overlay_con_p" >未成年人请勿饮酒！</p>
          <div style="flex: 1" />
        </div>

        <div style="margin-left: 40px; margin-right: 40px; margin-top: 30px">
          <van-button
            color="#E1EDDE"
            block
            round
            class="custom-button"
            @click="closedailog"
            >我已知悉</van-button
          >
        </div>

        <div style=" height: 30px;"/>
      </div>
      </div>
      
    </van-overlay>

     <!-- 是否团队点单 -->
     <van-overlay :show="showEnableTeamOrder" z-index="999">
      <div class="overlay_con" style="margin-left: 10px;margin-right: 10px;">
        <div class="overlay_con_content">
         <p style="text-align: center; height: 60px; line-height: 60px;font-weight: bold;">
          温馨提示
        </p>
        <p class="overlay_con_p" style="margin-left: 30px;margin-right: 30px;">您好，这张桌子已经有人点过餐，请问您还要继续点餐吗？ </p>
      
        <div style="margin-left: 1rem; margin-right: 1rem; margin-top: 60px;display: flex;">
          <van-button
            color="#E1EDDE"
            block
            round
            class="cancel-custom-button"
            @click="showEnableTeamOrder=false"
            >继续点餐</van-button
          >
          <div style="width: 4rem;"/>
          <van-button
            color="#E1EDDE"
            block
            round
            style="width: 28rem;"
            class="custom-button"
            @click="goToHistouryConsume"
            >查看已点餐品</van-button
          >
        </div>

        <div style=" height: 30px;"/>
      </div>
      </div>
      
    </van-overlay>
  </div>
</template>

<script>
import { handleSessionStorage } from "@/utils";
import {
  getDiningRoomList,
  getFoodList,
  getSetmealFoodInfo,
} from "@/api/foodOrder";
export default {
  name: "InputPeopleNum",
  props: {},
  data() {
    return {
      // numValue: "",
      showEnableTeamOrder:false,
      EnableTeamOrder:false, //是否团队点单
      errorMsg: "",
      showSelectModal: true,
      tableNumber: 1,
      saasCode:'',
      diningRoomId:'',
      inputTableNumber: "",

    };
  },
  components: {},
  created() {
    const queryData = this.$route.query;
    this.fromPage = queryData.fromPage;
    this.saasCode = queryData.saasCode;
    this.diningRoomId = queryData.diningRoomId;
    this.isFromMicropoint = queryData.isFromMicropoint;
    this.EnableTeamOrder = handleSessionStorage.get('EnableTeamOrder')
    this.updateEnableTeamOrderDailog()
  },

  mounted() {},
  methods: {
    /**查看消费*/
    goToHistouryConsume(){
       this.showEnableTeamOrder = false

    },
    /**关闭不要浪费粮食弹窗*/
    closedailog(){
      this.showSelectModal = false
      this.updateEnableTeamOrderDailog()
    },
    /**是否显示团队点单 提示窗口*/
    updateEnableTeamOrderDailog(){
    if(this.EnableTeamOrder){
         this.showEnableTeamOrder = true
    }else{
   
    }
   },
    onClickTableNumber(num) {
      this.tableNumber = num;
    },
    handleToOrderPage() {
      if (this.tableNumber == "more" && !this.inputTableNumber) {
        this.$toast("请输入就餐人数");
        return;
      }
      this.handleChangePeopleNum();
      this.$router.replace({
        name:  'Micropoint',
        query: this.saasCode
        ? { saasCode: this.saasCode, diningRoomId: this.diningRoomId }
          : { diningRoomId: this.diningRoomId },
      });
    },
    handleChangePeopleNum() {
      this.$store.dispatch(
        "order/SET_ORDER_PEOPLE",
        this.tableNumber == "more"
          ? this.inputTableNumber - 0
          : this.tableNumber
      );
    },
  },
};
</script>
<style scoped lang="scss">
.check_person_con {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  padding-top: 26px;
  box-sizing: border-box;
  .person_title_con {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 53px;
    img {
      width: 158px;
      height: 158px;
      margin-bottom: 16px;
    }
  }
  .select_number_con {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    border-radius: 32px 32px 0px 0px;
    flex: 1;
    padding: 48px 50px;
    .select_tips {
      margin: 64px 0 32px;
      position: relative;
      display: flex;
      align-items: center;

      p {
        // width: 150px;
        &::before {
          content: " ";
          position: absolute;
          width: 4px;
          height: 4px;
          top: 13px;
          left: -30px;
          border-radius: 50%;
          background-color: #333;
        }
        &::after {
          content: "";
          position: absolute;
          width: 4px;
          height: 4px;
          top: 13px;
          right: -30px;
          border-radius: 50%;
          background-color: #333;
        }
      }
      // span {
      //   width: 3px;
      //   height: 3px;
      //   border-radius: 50%;
      //   background-color: #333;
      // }
      &::before {
        content: " ";
        position: absolute;
        width: 51px;
        height: 1px;
        top: 13px;
        left: -90px;
        border-radius: 50%;
        background-color: #333;
      }
      &::after {
        content: "";
        position: absolute;
        width: 51px;
        height: 1px;
        top: 13px;
        right: -90px;
        border-radius: 50%;
        background-color: #333;
      }
    }
  }
}
.table_number_con {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  .table_number_item {
    padding: 20px 0;
    box-sizing: border-box;
    width: 22.5%;
    text-align: center;
    border: 1px solid #999999;
    border-radius: 40px;
    color: #333;
    margin-right: 20px;
    margin-bottom: 20px;
    font-size: 36px;
    &.active_item {
      background: #E1EDDE;
      border: 1px solid #E1EDDE;
      color: #849d80;
    }

    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}
.number_submit_btns {
  padding: 30px;
  width: 100%;
  margin-top: 120px;
}

.custom-button {
  color: #849d80 !important;
  font-weight: bold;
  font-size: 1rem !important;
}
.overlay_con_content{
 width: 100%;
          margin-left: 10px;
          margin-right: 10px;
          background-color: white;
          border-radius: 10px;
          align-items: center;
          color: #737a84;
          font-size: 37px;
}
.overlay_con_img{
width: 48px;
 height: 48px; 
 margin-top: 40px;
 margin-left: 48px
}
.overlay_con_p{

text-align: center;
 margin-top: 40px;
            height: 48px;
              line-height: 48px;
              color: #737a84;
              font-size: 34px;
              margin-left: 10px;
}
.cancel-custom-button{
  color: #97A0A9 !important;
  font-weight: bold;
  font-size: 1rem !important;
  background: white !important;
  border: 1px solid #EAEAEA;
}
</style>
